import { videoModel } from 'common/api/models/video';

/**
 * @param {*} raw
 * @return {CollectionModel.type}
 */
export const CollectionModel = (raw) => ({
  totalCount: raw.totalCount === undefined ? -1 : +raw.totalCount,
  pageNum: raw.pageNum === undefined ? 1 : +raw.pageNum,
  perPage: raw.perPage || 12,
  sortingKey: raw.sortingKey || 'displayDate',
  sortingOrder: raw.sortingOrder || 'desc',
  channelId: raw.channelId || -1,
  videos: raw.videos ? raw.videos.map(videoModel) : [],
});

/**
 * @typedef {{
 *  totalCount: number,
 *  pageNum: number,
 *  perPage: number,
 *  sortingKey: string,
 *  sortingOrder: string,
 *  channelId: number,
 *  videos: VideoModel.type[],
 * }}
 */
CollectionModel.type = null;
